import { Base64, LobbyGame } from "~/utils";

export const routeBuilder = {
  listGames: "/list-games",
  storybook: "/storybook",
  game: (lobbyGame: LobbyGame) => {
    const data = Base64.encode(JSON.stringify(lobbyGame));
    return `/game/${lobbyGame.id}/${data}`;
  },
};
